export enum TotpStatus {
  Loading = 'loading',
  Enabled = 'enabled',
  Disabled = 'disabled',
  Unavailable = 'unavailable',
}

export enum TotpSetupPhase {
  Closed = 'closed',
  Starting = 'starting',
  SetupFailed = 'setup-failed',
  Verifying = 'verifying',
  Activating = 'activating',
  ActivationFailed = 'activation-failed',
}

export type TotpPreferenceModel = {
  status: TotpStatus;
  enabled: boolean | null;
  pending: boolean;
  retry: () => Promise<void>;
};

export type TotpSetupModel = {
  open: boolean;
  phase: TotpSetupPhase;
  material: { sharedSecret: string; setupUri: string } | null;
  code: string;
  error: string | null;
  start: () => Promise<void>;
  retrySetup: () => Promise<void>;
  close: () => void;
  setCode: (_value: string) => void;
  retryActivation: () => Promise<void>;
};

export type TotpDisableModel = {
  open: boolean;
  pending: boolean;
  failed: boolean;
  start: () => void;
  close: () => void;
  confirm: () => Promise<void>;
};

export type UseTotpManagementResult = {
  preference: TotpPreferenceModel;
  setup: TotpSetupModel;
  disable: TotpDisableModel;
};
